import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import { FaShieldAlt } from 'react-icons/fa'; // Reliable shield container asset

const AlertsCard = () => {
  return (
    <div className="w-full bg-white border border-gray-100 rounded-2xl p-6 font-sans shadow-sm flex flex-col justify-between min-h-[340px]">
      
      {/* Top Header Row */}
      <div className="flex items-center gap-3">
        <div className="text-emerald-600 bg-emerald-50 rounded-xl p-1.5 flex items-center justify-center">
          <FaShieldAlt className="w-5 h-5" />
        </div>
        <h2 className="text-[17px] font-bold text-gray-900 tracking-tight">
          Alerts
        </h2>
      </div>

      {/* Middle Center State Illustration */}
      <div className="flex flex-col items-center text-center my-auto py-4">
        {/* Large Centered Check Shield */}
        <div className="relative mb-5 text-[#10B981] drop-shadow-sm">
          <FaShieldAlt className="w-16 h-16 fill-current" />
          {/* Inner custom checkmark layout overlay */}
          <div className="absolute inset-0 flex items-center justify-center text-white pb-0.5">
            <svg 
              className="w-6 h-6 stroke-[3.5]" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        {/* Text Details */}
        <h3 className="text-[18px] font-bold text-emerald-600 mb-2">
          No Active Alerts
        </h3>
        <p className="text-[13px] font-medium text-gray-500 max-w-[240px] leading-relaxed">
          All equipment is operating within safe ranges.
        </p>
      </div>

      {/* Bottom Footer Navigation Bar */}
      <div className="border-t border-gray-100 pt-4">
        <button className="w-full flex items-center justify-between text-[#0052FF] font-bold text-[14px] hover:opacity-80 transition-opacity group">
          <span>View alert history</span>
          <FiArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={2.5} />
        </button>
      </div>

    </div>
  );
};

export default AlertsCard;
